module.exports = __webpack_public_path__ + "static/media/submit-btn.d0ef43e9.png";